/** Avoid logging sensitive payloads in production builds. */

import { isReactLocalLikeEnv } from "./envConfig";

export function devLog(...args: unknown[]): void {
  if (isReactLocalLikeEnv()) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}

export function devError(message: string, _err?: unknown): void {
  if (isReactLocalLikeEnv()) {
    // eslint-disable-next-line no-console
    console.error(message);
  }
}
